import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoveLetter from "@/pages/LoveLetter";
import PasswordGate from "@/components/PasswordGate";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App grain">
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#FFF8F0",
                        color: "#4A3B32",
                        border: "1px solid #F4DCD6",
                        fontFamily: "'Manrope', sans-serif",
                    },
                }}
            />
            <PasswordGate>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<LoveLetter />} />
                    </Routes>
                </BrowserRouter>
            </PasswordGate>
        </div>
    );
}

export default App;
